import { actionUrl } from 'config/static-content';

export const PageNotFound = () => {
  window.location.assign(actionUrl.bgHome);
  return null;
};
